module.exports = __webpack_public_path__ + "img/Weilin Barcode Dynamic Recognition Software2.b895256b.jpg";